import script from "./Semantic.vue?vue&type=script&setup=true&lang=js"
export * from "./Semantic.vue?vue&type=script&setup=true&lang=js"

import "./Semantic.vue?vue&type=style&index=0&id=2dabc36e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dabc36e"]])

export default __exports__